import React from 'react';
import { Icons } from '../../../components/base/BootstrapComponents';
import Pagination from '../../../components/base/Pagination/Pagination';
import MobileCamerasItem from './MobileCamerasItem';

export default function MobileCamerasGrid(props) {
  const {
    hostList,
    hostListMeta,
    handleLoadingHostList,
    showOnMap = () => {},
  } = props;

  const scrollToTop = event => {
    const element = document.getElementById('parking-meter-scroll-block-1');
    element.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="mobile-parking-meter-table">
      <div className="mpm-hosts">
        {hostList.map((item, key) => (<MobileCamerasItem key={key} item={item} showOnMap={showOnMap} />))}
      </div>
      <div className="going-top-wrapper">
        <div className="going-top" onClick={scrollToTop}>
          <Icons width={24} height={24} customIcon icon="arrow-upward" className="going-top-icons" />
        </div>
      </div>
      <Pagination meta={hostListMeta} list={hostList} handleChangeMeta={handleLoadingHostList} />
    </div>
  );
}
